module.exports = __webpack_public_path__ + "static/media/logoATO.6617a7b0.png";